import axios from "axios";

export default {
    getReport: async (params) => {
        const { data } = await axios.get("/report", { params: params })

        return data
    }
}
